// data-mask

const masks = {
    cpf (value) {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    },
    onlyNumbers (value) {
      return value
        .replace(/\D/g, '');
    },
    cnpj (value) {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    },
    cpfCnpj(value) {
        value = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

        if (value.length <= 11) {
            // Aplica máscara de CPF
            return value
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1');
        } else {
            // Aplica máscara de CNPJ
            return value
                .replace(/(\d{2})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1/$2')
                .replace(/(\d{4})(\d)/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1');
        }
    },
    phone (value) {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
        .replace(/(-\d{4})\d+?$/, '$1');

    },
    phoneDDI (value) {
      return value
        .replace(/\D+/g, '')
        .replace(/(\d{2})(\d)/, '+$1 $2')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
        .replace(/(-\d{4})\d+?$/, '$1');
    },
    cep (value) {
      return value
        .replace(/\D+/g, '')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{3})\d+?$/, '$1');
    },
    pis (value) {
      return value
        .replace(/\D+/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{5})(\d)/, '$1.$2')
        .replace(/(\d{5}\.)(\d{2})(\d)/, '$1$2-$3')
        .replace(/(-\d)\d+?$/, '$1')
    },
    realbrl (value) {
      const cleanValue = +value.replace(/\D+/g, '')
      const options = { style: 'currency', currency: 'BRL' }
      return new Intl.NumberFormat('pt-br', options).format(cleanValue / 100);
    },

    email (value) {
        return value
            .toLowerCase()
            .replace(/\s/g, '') // remove espaços
            .replace(/[^a-z0-9@._-]/g, ''); // remove caracteres inválidos
    },
}

export default function initMaskInputs() {
  document.querySelectorAll('input[data-mask]').forEach(input => {
    const field = input.dataset.mask;

    input.addEventListener('input', (e)=> {
      e.target.value = masks[field](e.target.value);
    }, false);
  })
}
